module.exports = __webpack_public_path__ + "img/sign-waiting.44699996.svg";